import React from "react";
import { cn } from "../../../lib/utils";
import TimeAgoPill from "./TimeAgoPill";
import { AlertCircle } from "lucide-react";

export interface WorkflowStageInfoBannerProps {
  title: string;
  description?: string;
  timeAgo?: number;
  className?: string;
}

const WorkflowStageInfoBanner: React.FC<
  WorkflowStageInfoBannerProps
> = ({ title, description, timeAgo, className }) => {
  return (
    <div
      className={cn(
        "w-full rounded-[14px] border border-[#E5E7EB] bg-[#E5E7EB] px-4 py-3",
        "flex items-center justify-between gap-4",
        className
      )}
    >
      <div className="min-w-0 flex flex-col gap-0.5">
        <div className="min-w-0 flex items-center gap-2">
          <AlertCircle className="w-4 h-4 text-[#0A0A0A] shrink-0" />
          <span className="truncate font-['Inter'] text-base font-medium leading-6 tracking-normal text-[#0A0A0A]">
            {title}
          </span>

          {timeAgo ? (
            <TimeAgoPill days={timeAgo.toString()} />
          ) : null}
        </div>

        {description && (
          <span className="truncate font-['Inter'] text-sm font-normal leading-5 tracking-normal text-[#0A0A0A]">
            {description}
          </span>
        )}
      </div>
    </div>
  );
};

export default WorkflowStageInfoBanner;